<div class="popular-products" *ngIf="popularProducts.length">
  <vw-product-carousel
    [title]="
      !catalogCategory
        ? ('popularProducts.title' | translate)
        : ('popularProducts.titleCategory'
          | translate: { categoryName: catalogCategory.displayName })
    "
    [items]="popularProducts"
    [backgroundColor]="productCarouselBackgroundColor"
  ></vw-product-carousel>
</div>
